export const apiConfig = {
    baseUrl: process.env.REACT_APP_SERVER || '/iterm/v2',
    googleClientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || ''
  };
  